import {
    Icon,
    ListItemIcon,
    ListItemText,
    MenuItem,
    MenuList,
} from "@mui/material";
import { useState } from "react";
import { TMenuItemRelatorioProps } from "../vendas.model";
import "./MenuItems.css";

const initialState = {
  showImprimir: false as boolean,
  showIrPara: false as boolean,
};

const MenuItemAberto = (props: TMenuItemRelatorioProps) => {
  const [stateLocal, setStateLocal] = useState(initialState);
  const {
    canEditarVendedor = true,
    canCancelarPedido = true,
    canVisualizar = true,
    canConferir = true,
    canImprimir = true,
    canImprimirPreVenda = true,
    canImprimirPedido = true,
    canImprimirRomaneio = true,
    canImprimirEtiquetaVolume = true,
    canNavegaPreVenda = true,
    canNavegaPDV = true,
  } = props.acoes ?? {};

  return (
    <MenuList>
      <MenuItem
        key="menu-item-aberto-editar-pedido"
        disabled={!canEditarVendedor}
        onClick={props.onEditarVendedor}
      >
        <ListItemIcon>
          <Icon className="fa-solid fa-pen" sx={{ fontSize: "16px" }} />
        </ListItemIcon>
        <ListItemText>Editar vendedor</ListItemText>
      </MenuItem>

      <MenuItem
        key="menu-item-faturado-romaneioVenda-dropdown"
        id="menu-item-faturado-romaneioVenda-dropdown"
        disabled={!canImprimir}
        onClick={() =>
          setStateLocal((prevState) => ({
            ...prevState,
            showImprimir: !prevState.showImprimir,
          }))
        }
      >
        <ListItemIcon>
          <Icon className="fa-solid fa-print" sx={{ fontSize: "18px" }} />
        </ListItemIcon>
        <ListItemText>Imprimir</ListItemText>
        <Icon
          className={
            !stateLocal.showImprimir
              ? "fa-solid fa-angle-down"
              : "fa-solid fa-angle-up"
          }
          sx={{ fontSize: "18px" }}
        />
      </MenuItem>

      <div
        className={`menu-items-container ${stateLocal.showImprimir ? "opened" : "closed"}`}
        id="dropdown-imprimir-menu-item-aberto"
      >
        <MenuItem
          key="menu-item-faturado-imprimir-pre-venda"
          id="menu-item-faturado-imprimir-pre-venda"
          disabled={!canImprimirPreVenda}
          onClick={() => props.onImprimirPreVenda!(props.itemRef.current!)}
        >
          <ListItemIcon />
          <ListItemText>Pré-venda</ListItemText>
        </MenuItem>

        <MenuItem
          key="menu-item-faturado-imprimir-pedido"
          id="menu-item-faturado-imprimir-pedido"
          disabled={!canImprimirPedido}
          onClick={() =>
            props.onImprimirPedido!(props.itemRef.current!.uuidPedido)
          }
        >
          <ListItemIcon />
          <ListItemText>Pedido</ListItemText>
        </MenuItem>

        <MenuItem
          key="menu-item-faturado-romaneioVenda"
          id="menu-item-faturado-romaneioVenda"
          disabled={!canImprimirRomaneio}
          onClick={() =>
            props.onImprimirRomaneio!(props.itemRef.current!.uuidPedido)
          }
        >
          <ListItemIcon />
          <ListItemText>Romaneio</ListItemText>
        </MenuItem>

        <MenuItem
          key="menu-item-faturado-etiqueta-volume"
          id="menu-item-faturado-etiqueta-volume"
          disabled={!canImprimirEtiquetaVolume}
          onClick={() =>
            props.onImprimirEtiquetaVolume!(props.itemRef.current!.uuidPedido)
          }
        >
          <ListItemIcon />
          <ListItemText>Etiqueta Volume</ListItemText>
        </MenuItem>
      </div>

      <MenuItem
        key="menu-item-faturado-imprimir-dropdown"
        id="menu-item-faturado-imprimir-dropdown"
        disabled={!canNavegaPDV && !canNavegaPreVenda}
        onClick={() =>
          setStateLocal((prevState) => ({
            ...prevState,
            showIrPara: !prevState.showIrPara,
          }))
        }
      >
        <ListItemIcon>
          <Icon className="fa-solid fa-arrow-right" sx={{ fontSize: "18px" }} />
        </ListItemIcon>
        <ListItemText>Ir para</ListItemText>
        <Icon
          className={
            !stateLocal.showIrPara
              ? "fa-solid fa-angle-down"
              : "fa-solid fa-angle-up"
          }
          sx={{ fontSize: "18px" }}
        />
      </MenuItem>

      <div
        className={`menu-items-container ${stateLocal.showIrPara ? "opened" : "closed"}`}
        id="dropdown-ir-para-menu-item-aberto"
      >
        <MenuItem
          key="menu-item-aberto-navega-pre-venda"
          id="menu-item-aberto-navega-pre-venda"
          disabled={!canNavegaPreVenda}
          onClick={() =>
            props.onNavigatePreVenda!(
              props.itemRef.current!.uuidPedido,
              props.itemRef.current!.numeroPedido,
            )
          }
        >
          <ListItemText sx={{ paddingLeft: "37px" }}>Pré-venda</ListItemText>
        </MenuItem>

        <MenuItem
          key="menu-item-aberto-ir-pdv"
          disabled={!canNavegaPDV}
          onClick={() =>
            props.onNavigatePDV!(
              props.itemRef.current!.uuidPedido,
              props.itemRef.current!.numeroPedido,
            )
          }
        >
          <ListItemText sx={{ paddingLeft: "37px" }}>PDV</ListItemText>
        </MenuItem>
      </div>

      <MenuItem
        key="menu-item-aberto-visualizar-pedido"
        id="menu-item-aberto-visualizar-pedido"
        disabled={!canVisualizar}
        onClick={() =>
          props.onVisualizar(
            props.itemRef.current!.uuidPedido,
            props.itemRef.current!.numeroPedido,
          )
        }
      >
        <ListItemIcon>
          <Icon
            className="fa-solid fa-eye"
            sx={{ fontSize: "18px", width: "20px" }}
          />
        </ListItemIcon>
        <ListItemText>Visualizar</ListItemText>
      </MenuItem>

      <MenuItem
        key="menu-item-aberto-conferir-pedido"
        id="menu-item-aberto-conferir-pedido"
        disabled={!canConferir}
        onClick={() =>
          props.onNavigateConferencia!(props.itemRef.current!.uuidPedido)
        }
      >
        <ListItemIcon>
          <Icon className="fa-solid fa-list-check" sx={{ fontSize: "18px" }} />
        </ListItemIcon>
        <ListItemText>Conferir</ListItemText>
      </MenuItem>

      <MenuItem
        key="menu-item-aberto-cancelar-pedido"
        id="menu-item-aberto-cancelar-pedido"
        disabled={!canCancelarPedido}
        onClick={props.onCancelar}
      >
        <ListItemIcon>
          <Icon className="fa-solid fa-xmark" sx={{ fontSize: "18px" }} />
        </ListItemIcon>
        <ListItemText>Cancelar Pedido</ListItemText>
      </MenuItem>
    </MenuList>
  );
};

export default MenuItemAberto;
